import React from 'react';

import { CRContracts } from '../components/cr-tracker/cr-contracts';
import { CRTrackerProvider } from '../context/cr-tracker-provider';

const CrTracker = () => {
  return (
    <CRTrackerProvider>
      <CRContracts />
    </CRTrackerProvider>
  );
};

export default CrTracker;
